import { render, staticRenderFns } from "./DesktopReviews.vue?vue&type=template&id=e86f5028&scoped=true&"
import script from "./DesktopReviews.vue?vue&type=script&lang=js&"
export * from "./DesktopReviews.vue?vue&type=script&lang=js&"
import style0 from "./DesktopReviews.vue?vue&type=style&index=0&id=e86f5028&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86f5028",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CollectionReview: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/CollectionReview.vue').default})
